// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { DrugGroup } from '../_models/drug-group.model';
// Models
import { QueryParamsModel } from '../../_base/crud';

export enum DrugGroupActionTypes {
  AllDrugGroupsRequested = '[DrugGroups] All DrugGroups Requested',
  AllDrugGroupsLoaded = '[DrugGroups] All DrugGroups Loaded',
  DrugGroupOnServerCreated = '[DrugGroups] DrugGroup On Server Created',
  DrugGroupCreated = '[DrugGroups] DrugGroup Created',
  DrugGroupOnServerUpdated = '[DrugGroups] DrugGroup On Server Updated',
  DrugGroupUpdated = '[DrugGroups] DrugGroup Updated',
  DrugGroupOnServerDeleted = '[DrugGroups] DrugGroup On Server Deleted',
  DrugGroupDeleted = '[DrugGroups] DrugGroup Deleted',
  DrugGroupsPageRequested = '[DrugGroups] DrugGroups Page Requested',
  DrugGroupsPageLoaded = '[DrugGroups] DrugGroups Page Loaded',
  DrugGroupsPageCancelled = '[DrugGroups] DrugGroups Page Cancelled',
  DrugGroupsPageToggleLoading = '[DrugGroups] DrugGroups Page Toggle Loading',
  DrugGroupsActionToggleLoading = '[DrugGroups] DrugGroups Action Toggle Loading',
  ThrowDrugGroupError = '[DrugGroups] Throw Error',
  FireDrugGroupSuccess = '[DrugGroups] Fire Success',
}

export class DrugGroupOnServerCreated implements Action {
  readonly type = DrugGroupActionTypes.DrugGroupOnServerCreated;
  constructor(public payload: { drugGroup: DrugGroup }) {}
}

export class DrugGroupCreated implements Action {
  readonly type = DrugGroupActionTypes.DrugGroupCreated;
  constructor(public payload: { drugGroup: DrugGroup }) {}
}

export class ThrowDrugGroupError implements Action {
  readonly type = DrugGroupActionTypes.ThrowDrugGroupError;
  constructor(public payload: { error: any }) {}
}

export class FireDrugGroupSuccess implements Action {
  readonly type = DrugGroupActionTypes.FireDrugGroupSuccess;
  constructor(public payload: { action_type: string }) {}
}

export class DrugGroupOnServerUpdated implements Action {
  readonly type = DrugGroupActionTypes.DrugGroupOnServerUpdated;
  constructor(
    public payload: {
      partialDrugGroup: Update<DrugGroup>;
      drugGroup: DrugGroup;
    },
  ) {}
}
export class DrugGroupUpdated implements Action {
  readonly type = DrugGroupActionTypes.DrugGroupUpdated;
  constructor(
    public payload: {
      partialDrugGroup: Update<DrugGroup>;
      drugGroup: DrugGroup;
    },
  ) {}
}

export class DrugGroupOnServerDeleted implements Action {
  readonly type = DrugGroupActionTypes.DrugGroupOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class DrugGroupDeleted implements Action {
  readonly type = DrugGroupActionTypes.DrugGroupDeleted;
  constructor(public payload: { id: number }) {}
}

export class DrugGroupsPageRequested implements Action {
  readonly type = DrugGroupActionTypes.DrugGroupsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class DrugGroupsPageLoaded implements Action {
  readonly type = DrugGroupActionTypes.DrugGroupsPageLoaded;
  constructor(
    public payload: { drugGroups: DrugGroup[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class DrugGroupsPageCancelled implements Action {
  readonly type = DrugGroupActionTypes.DrugGroupsPageCancelled;
}

export class DrugGroupsPageToggleLoading implements Action {
  readonly type = DrugGroupActionTypes.DrugGroupsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class DrugGroupsActionToggleLoading implements Action {
  readonly type = DrugGroupActionTypes.DrugGroupsActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export type DrugGroupActions =
  | DrugGroupCreated
  | DrugGroupUpdated
  | DrugGroupDeleted
  | DrugGroupOnServerCreated
  | DrugGroupOnServerUpdated
  | DrugGroupOnServerDeleted
  | DrugGroupsPageLoaded
  | DrugGroupsPageCancelled
  | DrugGroupsPageToggleLoading
  | DrugGroupsPageRequested
  | ThrowDrugGroupError
  | FireDrugGroupSuccess
  | DrugGroupsActionToggleLoading;
